import {BadResponseError} from '@/model/errors/BadResponseError';
import {ErrorWithUserMessage} from '@/model/errors/ErrorWithUserMessage';
import {NetworkError} from '@/model/errors/NetworkError';
import {Either, left, right} from 'fp-ts/lib/Either';

export class HttpClient {
    /**
     * @deprecated Use safeRequest which forces you to handle more than just happy path
     */
    public request(input: RequestInfo, init?: RequestInit): Promise<Response> {
        return fetch(input, init);
    }

    /**
     * Calls remote API and returns Promise that resolves to either:
     *  - JSON payload (as Right)
     *  - ErrorWithUserMessage (as Left) when API specified message to show to user
     *  - NetworkError (as Left) when connection to server could not be established
     *  - BadResponseError (as Left) when API returned response with error HTTP code
     */
    public async safeRequest<TPayload>(
        input: RequestInfo,
        init?: RequestInit,
    ): Promise<Either<ErrorWithUserMessage | NetworkError | BadResponseError, TPayload>> {
        try {
            const response = await fetch(input, init);

            const json = (await response.json() as TPayload & {user_message?: string});

            if (!response.ok) {
                return left(
                    typeof(json.user_message) === 'string'
                        ? new ErrorWithUserMessage(json.user_message)
                        : new BadResponseError(
                            `API returned error state: ${response.status} ${response.statusText}`,
                            response.status,
                        ),
                );
            }

            return right(json);
        } catch (e) {
            return left(new NetworkError(e));
        }
    }
}
